import { 
  ref, 
  uploadBytes, 
  getDownloadURL, 
  deleteObject 
} from 'firebase/storage';
import { 
  doc, 
  setDoc, 
  getDoc 
} from 'firebase/firestore';
import { storage, db } from '../firebase';

// Upload profile picture
export const uploadProfilePicture = async (userId, file) => {
  try {
    // Validate file type
    if (!file.type.startsWith('image/')) {
      throw new Error('Please select an image file');
    }

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      throw new Error('File size must be less than 5MB');
    }

    // Debug: Check if user is authenticated
    const { auth } = await import('../firebase');
    const currentUser = auth.currentUser;
    console.log('Current user:', currentUser);
    console.log('User ID:', userId);
    console.log('User authenticated:', !!currentUser);

    if (!currentUser) {
      throw new Error('User not authenticated');
    }

    // Create storage reference
    const storageRef = ref(storage, `profile-pictures/${userId}`);
    console.log('Storage ref path:', storageRef.fullPath);
    
    // Upload file
    const snapshot = await uploadBytes(storageRef, file);
    
    // Get download URL
    const downloadURL = await getDownloadURL(snapshot.ref);
    
    // Save URL to user document in Firestore
    await setDoc(doc(db, 'users', userId), {
      profilePictureURL: downloadURL,
      updatedAt: new Date()
    }, { merge: true });
    
    return downloadURL;
  } catch (error) {
    console.error('Error uploading profile picture:', error);
    throw error;
  }
};

// Get profile picture URL
export const getProfilePictureURL = async (userId) => {
  try {
    const userDoc = await getDoc(doc(db, 'users', userId));
    if (userDoc.exists()) {
      return userDoc.data().profilePictureURL || null;
    }
    return null;
  } catch (error) {
    console.error('Error getting profile picture URL:', error);
    return null;
  }
};

// Delete profile picture
export const deleteProfilePicture = async (userId) => {
  try {
    // Delete from Storage
    const storageRef = ref(storage, `profile-pictures/${userId}`);
    await deleteObject(storageRef);
    
    // Remove URL from Firestore
    await setDoc(doc(db, 'users', userId), {
      profilePictureURL: null,
      updatedAt: new Date()
    }, { merge: true });
    
    return true;
  } catch (error) {
    console.error('Error deleting profile picture:', error);
    throw error;
  }
};

// Update user birthday
export const updateUserBirthday = async (userId, birthday) => {
  try {
    await setDoc(doc(db, 'users', userId), {
      birthday: birthday,
      updatedAt: new Date()
    }, { merge: true });
    
    return true;
  } catch (error) {
    console.error('Error updating birthday:', error);
    throw error;
  }
};

// Get user birthday
export const getUserBirthday = async (userId) => {
  try {
    const userDoc = await getDoc(doc(db, 'users', userId));
    if (userDoc.exists()) {
      return userDoc.data().birthday || null;
    }
    return null;
  } catch (error) {
    console.error('Error getting birthday:', error);
    return null;
  }
};
